import React, { Component } from 'react';
import { Icon } from 'antd';

class FavButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.handleClick('new');
  }

  render() {
    return (
      <button className="btn btn-primary d-flex align-items-center justify-content-center" onClick={this.handleClick} style={{ width: '60px', height: '60px', position: 'fixed', bottom: '30px', right: '30px', borderRadius: '30px' }}>
        <Icon type="plus" style={{ fontSize: '1.4em' }} />
      </button>
    );
  }
}

export default FavButton;



// WEBPACK FOOTER //
// ./src/components/FavButton.js